import { useQuery } from '@hooks/reactQuery';

import { getOranValuesForCreate } from '@api/schemaConfig';

import { optionsFormattedWithArray } from '@utils/formatter';

import { refetchOptions } from '@constants/common';
import { ORAN_VALUES_FOR_CREATE_SCHEMA } from '@constants/queryKeys';

const useQueryValuesForCreate = () => {
	const {
		data,
		isLoading,
	} = useQuery({
		queryKey: [ORAN_VALUES_FOR_CREATE_SCHEMA],
		queryFn: getOranValuesForCreate,
		select: (data) => {
			return optionsFormattedWithArray(data?.presetNames || []);
		},
		...refetchOptions,
	});

	return {
		presetNames: data || [],
		isLoadingPresetNames: isLoading,
	};
};

export default useQueryValuesForCreate;
